// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-cols[data-v-5ef018bd] {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  row-gap: 24px;\n  -moz-column-gap: 160px;\n       column-gap: 160px;\n}\n.table-cols .col[data-v-5ef018bd] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  min-width: 110px;\n}\n.trade-dialog-add[data-v-5ef018bd] {\n  display: flex;\n  -moz-column-gap: 10px;\n       column-gap: 10px;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
